export const BEFORE_OPENING = 'BEFORE_OPENING';
export const BEFORE_CLOSING = 'BEFORE_CLOSING';

export const mandatoryConditions = [BEFORE_OPENING, BEFORE_CLOSING];
